"use client";

import React from "react";
import { Clock, Heart, GraduationCap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  id: 1,
  number: "7,300",
  label: "Days Passed",
  icon: Clock
}, {
  id: 2,
  number: "1,000+",
  label: "Shared Memories",
  icon: Heart
}, {
  id: 3,
  number: "1",
  label: "Epic Reunion",
  icon: GraduationCap
}];
export default function TwentyYearsInTheMaking() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="20-years-in-the-making" className="bg-background text-foreground">
      <div className="bg-card py-24 px-4 border-y border-border/40">
        <div ref={ref} className={`container mx-auto max-w-5xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8 text-center">
            {stats.map((stat, i) => {
            const Icon = stat.icon;
            return <div key={stat.id} data-index={i} className="flex flex-col items-center justify-center">
                  <Icon className="size-12 text-primary mb-6" strokeWidth={1} aria-hidden="true" />
                  <div className="font-default text-5xl md:text-6xl font-bold text-primary mb-3 tracking-tight">
                    {stat.number}
                  </div>
                  <p className="font-sans text-base md:text-lg text-muted-foreground uppercase tracking-widest font-medium">
                    {stat.label}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}